import { render, staticRenderFns } from "./PTDetailList.vue?vue&type=template&id=c8f0f6ac&"
import script from "./PTDetailList.vue?vue&type=script&lang=js&"
export * from "./PTDetailList.vue?vue&type=script&lang=js&"
import style0 from "./PTDetailList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports